import { useWeekdays } from "../../../common/useWeekdays";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { capitalizeFirstLetter, notEmpty, onlyUnique } from "../../../utils";

export function useDaysDescription(_byweekday: (number | null | undefined)[]) {
  const weekdays = useWeekdays("narrow");
  const byweekday = _byweekday.filter(notEmpty).filter(onlyUnique);
  const intl_token = useIntlTokens();

  if (
    byweekday.length === 5 &&
    [0, 1, 2, 3, 4].every((v) => byweekday.includes(v))
  ) {
    return intl_token.Weekdays_excluding_weekend;
  }
  if (byweekday.length === 7 || byweekday.length === 0) {
    return intl_token.EveryDay;
  }
  if (byweekday.length === 1) {
    return intl_token.Weekly;
  }

  return byweekday
    .map((day) => capitalizeFirstLetter(weekdays[day]))
    .join(", ");
}
